export default __webpack_public_path__ + "static/media/basry-logo.1cc8a763.png";